import { render, staticRenderFns } from "./CreateCustomBill.vue?vue&type=template&id=b0837878"
import script from "./CreateCustomBill.vue?vue&type=script&lang=js"
export * from "./CreateCustomBill.vue?vue&type=script&lang=js"
import style0 from "./CreateCustomBill.vue?vue&type=style&index=0&id=b0837878&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports